import React, { FC, ReactNode } from 'react';

import { IconType, Semibold, ZZMColor } from '@zazume/zzm-base';

import { FieldValueBase, FieldValueBaseProps } from '#/components/pages/detail/FieldsSection/atoms/FieldValueBase';

import { FieldValues } from './fields/index';

export interface FieldValueProps extends FieldValueBaseProps {
  value?: string | null | ReactNode;
  emptyValue?: string;
  icon?: IconType;
  color?: ZZMColor;
  withCopy?: boolean;
  fullWidth?: boolean;
}

type Component = FC<FieldValueProps> & {
  Skeleton: typeof Skeleton;
};

export const FieldValue: Component = ({
  title,
  value,
  emptyValue = '-',
  isDefaultHidden,
  icon,
  color = 'Gray600',
  withCopy,
  tooltip,
  fullWidth
}) => {
  return (
    <FieldValueBase title={title} isDefaultHidden={isDefaultHidden} tooltip={tooltip} fullWidth={fullWidth}>
      <FieldValues.Text
        icon={icon}
        color={color}
        value={value}
        emptyValue={emptyValue}
        withCopy={withCopy}
      ></FieldValues.Text>
    </FieldValueBase>
  );
};

const Skeleton: FC<{ title: string }> = ({ title }) => (
  <FieldValue title={title} value={<Semibold.Skeleton width={title.length} />} />
);

FieldValue.Skeleton = Skeleton;
